import '@/plugins/luxon.ts'
import type { User } from '@sortera/dvfv-auth'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createApp } from 'vue'
import flatPickr from 'vue-flatpickr-component'

import App from '@/App.vue'
import { usePluginAnalytics } from '@/plugins/analytics.ts'
import { usePluginLuxon } from '@/plugins/luxon.ts'
import { usePluginPersistence } from '@/plugins/persistence.ts'
import { useThemePlugin } from '@/plugins/theme.ts'
// eslint-disable-next-line no-restricted-imports
import { routerInstance } from '@/services/routing/router-instance.ts'
// eslint-disable-next-line no-restricted-imports
import { i18nInstance } from '@/services/translation/i18n-instance.ts'
import { useUser } from '@/services/use-user.ts'

// eslint-disable-next-line no-restricted-imports
import { useFirestore, usePluginFirestore } from './plugins/firebase.ts'

import '@/assets/global.css'

usePluginLuxon()

const app = createApp(App)

app.use(i18nInstance)

app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        gcTime: 1000 * 60 * 60 * 24,
        // staleTime: 1000 * 10,
      },
    },
  },
})

usePluginFirestore()
const firestore = useFirestore()
usePluginPersistence(firestore)

app.component('FlatPickr', flatPickr)
app.use(routerInstance)

function getUser(): User | null | undefined {
  return useUser().user.value
}

useThemePlugin()
usePluginAnalytics(app, routerInstance, getUser)

app.mount('#app')
